import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import axiosInstance from "../../../services/AxiosInstance";
import moment from "moment";
import "./notification.css";
import { getActiveSubscriptions, clearSubscriptionCache } from "../../../utils/subscriptionCache";

import { Link, useNavigate } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';
import EditProfileCorporate from './EditProfileCorporate';
import EditProfileCorporateUser from './EditProfileCorporateUser';

import "./headerstyle.css";

const notificationTypeMap = {
  10: "assignee",
  20: "tag",
  30: "observer",
  40: "participant",
  50: "status",
  60: "new_comment",
  70: "comment_reply",
  80: "mention",
  90: "start_date_reminder",
  100: "inactive_task"
};
const returnStatusMap = {
  "-1": "Overdue",
  "0": "Pending",
  "1": "In-Progess",
  "2": "Blocked",
  "3": "Completed",
  "4": "Paused"
};
const headerNameDictionary = {
  edittask: "Edit Task",
  addtask: "Add Task",
  projectlist: "Project List",
  editproject: "Edit Project",
  projectdetails: "Project Details",
  addproject: "Add Project",
  tasklist: "Tasks",
  taskboard: "Task Board",
  performance: "Performance Dashboard",
  performancedetails: "Performance Details",
  taskdetails: "Task Details",
  userlist: "User List",
  adduser: "Add User",
  edituser: "Edit User",
  branchList: "Branch List",
  departmentList: "Department List",
  editBranch: "Edit Branch",
  editbranch: "Edit Branch",
  addBranch: "Add Branch",
  addbranch: "Add Branch",
  addDepartment: "Add Department",
  adddepartment: "Add Department",
  editDepartment: "Edit Department",
  editdepartment: "Edit Department",
  modules: "Modules",
  subscription: "Subscription",
  usersubscription: "Manage Your Subscription",
  renew: "Subscription Renewal",
  subscriptionfeaturerequired: "Feature not available",
  dashboard: "Dashboard",
  dashboarddark: "Dashboard Dark",
  draggable: "Draggable",
  messages: "Messages",
  projectdetails: "Project Details",
  latestactivity: "Latest Activity",
  clients: "Clients",
  task: "Task",
  horizontalsidebar: "Horizontal Sidebar",
  navheader: "Nav Header",
  dashboardheader: "Dashboard Header",
  primarysidebar: "Primary Sidebar",
  darksidebar: "Dark Sidebar",
  minisidebar: "Mini Sidebar",
  appprofile: "App Profile",
  emailcompose: "Compose Email",
  emailinbox: "Inbox",
  emailread: "Read Email",
  appcalender: "Calendar",
  postdetails: "Post Details",
  ecomproductgrid: "Product Grid",
  ecomproductlist: "Product List",
  ecomproductdetail: "Product Detail",
  ecomproductorder: "Product Order",
  ecomcheckout: "Checkout",
  ecominvoice: "Invoice",
  ecomcustomers: "Customers",
  chartsparkline: "Sparkline Chart",
  chartchartjs: "Chart.js",
  chartapexchart: "Apex Chart",
  chartrechart: "Rechart",
  uialert: "Alert",
  uibadge: "Badge",
  uibutton: "Button",
  uimodal: "Modal",
  uibuttongroup: "Button Group",
  uiaccordion: "Accordion",
  uilistgroup: "List Group",
  uicard: "Card",
  uicarousel: "Carousel",
  uidropdown: "Dropdown",
  uipopover: "Popover",
  uiprogressbar: "Progress Bar",
  uitab: "Tab",
  uipagination: "Pagination",
  uitypography: "Typography",
  uigrid: "Grid",
  ucselect2: "Select2",
  ucnouislider: "Noui Slider",
  ucsweetalert: "SweetAlert",
  uctoastr: "Toastr",
  mapjqvmap: "JQV Map",
  uclightgallery: "Light Gallery",
  editSubDepartment: "Edit Sub Department",
  addsubdepartment: "Add Sub Department",
  documents: "Documents",
  staff: "Staff",
  vehicle: "Vehicle",
  staffdetails: "Staff Details",
  vehicledetails: "Vehicle Details",
  vaultsettings: "Credentials Vault",
  credentialvaultsection: "Credentials Vault",
  credentialvaultlist: "Corporate credentials",
  personalvaultlist: "Personal credentials",
  credentialdetail: "Credential Details",
};
const Header = ({ }) => {
  const navigate = useNavigate();
  const [searchBut, setSearchBut] = useState(false);
  const [userName, setUserName] = useState(null);
  var path = window.location.pathname.split("/");
  // If the previous segment is 'taskdetails', use that as the header key
  var last = path[path.length - 1];
  var prev = path[path.length - 2];
  var name = last.split("-");
  const domain = path[1];
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName;
  let headerTitleKey = finalName.join("").toLowerCase();
  if (last.toLowerCase() === "worksheet") {
    headerTitleKey = "worksheet";
  } else if (last.toLowerCase() === "tasklist") {
    headerTitleKey = "tasklist";
  } else if (last.toLowerCase() === "performance") {
    headerTitleKey = "performance";
  } else if (
    last.toLowerCase() === "details" &&
    prev &&
    prev.toLowerCase() === "performance"
  ) {
    headerTitleKey = "performancedetails";
  } else if (last.toLowerCase() === "subscription-feature-required") {
    headerTitleKey = "subscriptionfeaturerequired";
  }
  if (domain === "documents") {
    headerTitleKey = "documents";
  } else if (domain === "staff") {
    headerTitleKey = "staff";
  } else if (domain === "vehicle") {
    headerTitleKey = "vehicle";
  }

  if (prev && prev.toLowerCase() === "taskdetails") {
    headerTitleKey = "taskdetails";
  } else if (prev && prev.toLowerCase() === "projectdetails") {
    headerTitleKey = "projectdetails";
  } else if (prev && prev.toLowerCase() === "editbranch") {
    headerTitleKey = "editBranch";
  } else if (prev && prev.toLowerCase() === "addbranch") {
    headerTitleKey = "addBranch";
  } else if (prev && prev.toLowerCase() === "editdepartment") {
    headerTitleKey = "editDepartment";
  } else if (prev && prev.toLowerCase() === "adddepartment") {
    headerTitleKey = "addDepartment";
  } else if (prev && prev.toLowerCase() === "editsubdepartment") {
    headerTitleKey = "editSubDepartment";
  } else if (prev && prev.toLowerCase() === "addsubdepartment") {
    headerTitleKey = "addSubDepartment";
  } else if (prev && prev.toLowerCase() === "editvehicle") {
    headerTitleKey = "editVehicle";
  } else if (prev && prev.toLowerCase() === "staffdetails") {
    headerTitleKey = "staffdetails";
  } else if (prev && prev.toLowerCase() === "vehicledetails") {
    headerTitleKey = "vehicledetails";
  } else if (prev && prev.toLowerCase() === "credentialdetail") {
    headerTitleKey = "credentialvaultsection";
  } else if (last.toLowerCase() === "vaultsettings") {
    headerTitleKey = "vaultsettings";
  } else if (domain === "credential-vault" && last.toLowerCase() === "addcredential") {
    headerTitleKey = "credentialvaultsection";
  } else if (domain === "credential-vault" && prev && prev.toLowerCase() === "editcredential") {
    headerTitleKey = "credentialvaultsection";
  }
  let user = localStorage.getItem('user');
  let userType = null;
  let isCorporateUser = false;
  if (user) {
    try {
      const parsed = JSON.parse(user);
      userType = parsed.type || parsed.role || parsed.userType || null;
      isCorporateUser = (userType || '').toLowerCase() === 'corporate';
    } catch (e) { userType = null; }
  }

  const subscribeHandler = () => {
    navigate('/subscribe')
  }

  const userPlanFeatures = async () => {
    try {
      const response = await axiosInstance.get(`/userSubscription/features`);
      if (response.data && response.data.features) {
        localStorage.setItem('userPlanFeatures', JSON.stringify(response.data.features));
      }
    } catch (error) {
      console.error('Error fetching user plan features:', error);
    }
  }

  useEffect(() => {
    userPlanFeatures();
  }, []);

  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [subscriptionsInRenewal, setSubscriptionsInRenewal] = useState([]);
  const [showRenewalDropdown, setShowRenewalDropdown] = useState(false);
  const [isTickerVisible, setIsTickerVisible] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const scrollbarRef = useRef(null);
  const stateRef = useRef({ page, hasMore, loadingMore, loading });
  
  // Keep refs in sync with state
  useEffect(() => {
    stateRef.current = { page, hasMore, loadingMore, loading };
  }, [page, hasMore, loadingMore, loading]);

  const fetchNotifications = async (pageNum = 1, append = false) => {
    try {
      if (pageNum === 1) setLoading(true);
      else setLoadingMore(true);
      
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;
      setUserName(user.name);
      
      const params = new URLSearchParams({
        page: pageNum,
        limit: 10,
      });
      
      const res = await axiosInstance.get(`/notification/list/${userId}?${params.toString()}`);
      const fetchedNotifications = res.data.notifications || [];
      
      if (append) {
        setNotifications((prev) => [...prev, ...fetchedNotifications]);
      } else {
        setNotifications(fetchedNotifications);
      }
      
      // Check if there are more notifications to load
      setHasMore(fetchedNotifications.length === 10);
      setPage(pageNum);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  // Build notification message; returns JSX or plain text as needed
  const getNotificationMessage = (notif, { plainText = false } = {}) => {
    const taskTitle = notif.task?.title || notif.task_title || '';
    const titleForText = taskTitle || 'a task';
    const highlightedTaskName = plainText
      ? titleForText
      : <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{titleForText}</span>;

    const statusLabel = returnStatusMap[notif.table_value] || notif.table_value;

    switch (notif.type) {
      case 10:
        return plainText ? `You have been assigned to task ${titleForText}` : <>You have been assigned to task {highlightedTaskName}</>;
      case 20:
        return plainText ? `You were tagged in task ${titleForText}` : <>You were tagged in task {highlightedTaskName}</>;
      case 30:
        return plainText ? `You are an observer for task ${titleForText}` : <>You are an observer for task {highlightedTaskName}</>;
      case 40:
        return plainText ? `You are a participant in task ${titleForText}` : <>You are a participant in task {highlightedTaskName}</>;
      case 50:
        return plainText ? `Your task ${titleForText} status changed to ${statusLabel}` : <>Your task {highlightedTaskName} status is changed to {statusLabel}</>;
      case 60:
        return plainText ? `A new comment was added to task ${titleForText}` : <>A new comment was added to task {highlightedTaskName}</>;
      case 70:
        return plainText ? `Someone replied to your comment on task ${titleForText}` : <>Someone replied to your comment on task {highlightedTaskName}</>;
      case 80:
        return plainText ? `You were mentioned in task ${titleForText}` : <>You were mentioned in task {highlightedTaskName}</>;
      case 90:
        return plainText ? `Task ${titleForText} starts in 2 days` : <>Task {highlightedTaskName} is starting in 2 days</>;
      case 100:
        return plainText ? `Task ${titleForText} should have started but has not been activated` : <>Task {highlightedTaskName} should have started but hasn't been activated</>;
      default:
        return plainText ? (notif.title || notif.message || notif.content || 'Notification') : (notif.title || notif.message || notif.content || <>Notification (Type: {notif.type})</>);
    }
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;
      await axiosInstance.post(`/notification/read`, {
        id: notificationId,
        userid: userId,
      });
      // Always set is_read to true
      setNotifications((prev) =>
        prev.map((notif) =>
          notif.id === notificationId ? { ...notif, is_read: true } : notif
        )
      );
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  /**
   * Handle clicking on a notification:
   * - mark it as read
   * - navigate to the related task details when available
   */
  const handleNotificationClick = async (notif) => {
    // Mark notification as read first
    if (notif?.id) {
      await markNotificationAsRead(notif.id);
    }

    // Always close the dropdown when we act on a notification
    setShowNotifications(false);

    // Try common shapes for the task id coming from the API
    const taskId =
      notif?.task?.id ||
      notif?.task?.taskid ||
      notif?.task_id ||
      notif?.taskid;

    if (taskId) {
      navigate(`/task/taskdetails/${taskId}`);
    }
  };

  const unreadNotifications = useMemo(
    () => notifications.filter((n) => !n.is_read).slice(0, 3),
    [notifications]
  );

  useEffect(() => {
    fetchNotifications(1, false);
  }, []);

  const isWithinRenewalPeriod = (subscription) => {
    if (!subscription?.end_date) return false;
    const endDate = new Date(subscription.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const daysUntilExpiry = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
    const subType = (subscription.subscription_type || '').toLowerCase();
    const renewalDays = subType === 'yearly' ? 10 : 5;
    return daysUntilExpiry >= 0 && daysUntilExpiry <= renewalDays;
  };

  const isExpired = (subscription) => {
    if (!subscription?.end_date) return false;
    const endDate = new Date(subscription.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate < today;
  };

  const fetchRenewalSubscriptions = async () => {
    try {
      const res = await getActiveSubscriptions();
      const subs = res?.subscriptions || [];
      const inRenewal = subs.filter((s) => isWithinRenewalPeriod(s) || isExpired(s));
      setSubscriptionsInRenewal(inRenewal);
    } catch (e) {
      setSubscriptionsInRenewal([]);
    }
  };

  useEffect(() => {
    fetchRenewalSubscriptions();
  }, []);

  useEffect(() => {
    if (showRenewalDropdown) {
      fetchRenewalSubscriptions();
    }
  }, [showRenewalDropdown]);

  useEffect(() => {
    const onSubscriptionUpdate = () => {
      clearSubscriptionCache();
      fetchRenewalSubscriptions();
    };
    window.addEventListener('user-subscription-updated', onSubscriptionUpdate);
    return () => window.removeEventListener('user-subscription-updated', onSubscriptionUpdate);
  }, []);

  // Reset pagination when dropdown is opened
  useEffect(() => {
    if (showNotifications) {
      // Refresh notifications when dropdown opens
      fetchNotifications(1, false);
    }
  }, [showNotifications]);

  // Handle scroll for infinite loading
  useEffect(() => {
    if (!showNotifications) return;

    let scrollContainer = null;
    let handleScroll = null;

    // Wait for dropdown to be rendered, then find the PerfectScrollbar container
    const timer = setTimeout(() => {
      scrollContainer = document.querySelector('.notification_dropdown .ps');
      if (!scrollContainer) return;

      handleScroll = () => {
        const scrollTop = scrollContainer.scrollTop;
        const scrollHeight = scrollContainer.scrollHeight;
        const clientHeight = scrollContainer.clientHeight;
        
        // Use refs to get latest state values
        const { hasMore: currentHasMore, loadingMore: currentLoadingMore, loading: currentLoading, page: currentPage } = stateRef.current;
        
        // Load more when scrolled near bottom (within 50px)
        const threshold = 50;
        if (
          scrollHeight - scrollTop - clientHeight < threshold &&
          currentHasMore &&
          !currentLoadingMore &&
          !currentLoading
        ) {
          fetchNotifications(currentPage + 1, true);
        }
      };

      scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
    }, 100);

    return () => {
      clearTimeout(timer);
      if (scrollContainer && handleScroll) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [showNotifications]); // Only re-attach when dropdown opens/closes

  // Add this function to format header names
  function formatHeaderName(str) {
    return str
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      .replace(/\b\w/g, c => c.toUpperCase())
      .trim();
  }

  return (
    <div className="header border-bottom">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize", }}
              >
                {(() => {
                  if (headerTitleKey.length === 0 || headerTitleKey === "dashboarddark") {
                    return "Dashboard";
                  } else if (headerNameDictionary[headerTitleKey]) {
                    return headerNameDictionary[headerTitleKey];
                  } else {
                    return formatHeaderName(finalName.join(" "));
                  }
                })()}
              </div>
            </div>
            <ul className="navbar-nav header-right">
              {isCorporateUser && subscriptionsInRenewal.length > 0 && (
                <Dropdown
                  as="li"
                  className="nav-item dropdown renewal_dropdown"
                  show={showRenewalDropdown}
                  onToggle={(isOpen) => setShowRenewalDropdown(isOpen)}
                >
                  <Dropdown.Toggle
                    className="nav-link i-false c-pointer"
                    variant=""
                    as="a"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    style={{ position: 'relative' }}
                  >
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" fill="#717579"/>
                    </svg>
                    <div className="renewal-icon-badge"></div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end" style={{ minWidth: '300px', maxWidth: '360px' }}>
                    <div style={{ padding: '16px' }}>
                      <p style={{ margin: '0 0 12px 0', fontSize: '14px', lineHeight: 1.5, color: '#374151' }}>
                        Your subscription is coming up for renewal. Please renew now to have uninterrupted usage.
                      </p>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          setShowRenewalDropdown(false);
                          navigate(`/subscription/renew?subscriptionId=${subscriptionsInRenewal[0]?.id || ''}`);
                        }}
                        style={{ backgroundColor: '#C42126', borderColor: '#C42126' }}
                      >
                        Renew
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              )}
              <Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown"
                show={showNotifications}
                onToggle={(isOpen) => setShowNotifications(isOpen)}
              >
                <Dropdown.Toggle
                  className="nav-link i-false c-pointer"
                  variant=""
                  as="a"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  style={{ position: 'relative' }}
                >
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.3333 19.8333H23.1187C23.2568 19.4597 23.3295 19.065 23.3333 18.6666V12.8333C23.3294 10.7663 22.6402 8.75902 21.3735 7.12565C20.1068 5.49228 18.3343 4.32508 16.3333 3.80679V3.49996C16.3333 2.88112 16.0875 2.28763 15.6499 1.85004C15.2123 1.41246 14.6188 1.16663 14 1.16663C13.3812 1.16663 12.7877 1.41246 12.3501 1.85004C11.9125 2.28763 11.6667 2.88112 11.6667 3.49996V3.80679C9.66574 4.32508 7.89317 5.49228 6.6265 7.12565C5.35983 8.75902 4.67058 10.7663 4.66667 12.8333V18.6666C4.67053 19.065 4.74316 19.4597 4.88133 19.8333H4.66667C4.35725 19.8333 4.0605 19.9562 3.84171 20.175C3.62292 20.3938 3.5 20.6905 3.5 21C3.5 21.3094 3.62292 21.6061 3.84171 21.8249C4.0605 22.0437 4.35725 22.1666 4.66667 22.1666H23.3333C23.6428 22.1666 23.9395 22.0437 24.1583 21.8249C24.3771 21.6061 24.5 21.3094 24.5 21C24.5 20.6905 24.3771 20.3938 24.1583 20.175C23.9395 19.9562 23.6428 19.8333 23.3333 19.8333Z" fill="#717579" />
                    <path d="M9.98192 24.5C10.3863 25.2088 10.971 25.7981 11.6766 26.2079C12.3823 26.6178 13.1839 26.8337 13.9999 26.8337C14.816 26.8337 15.6175 26.6178 16.3232 26.2079C17.0288 25.7981 17.6135 25.2088 18.0179 24.5H9.98192Z" fill="#717579" />
                  </svg>
                  {notifications.some(notif => !notif.is_read) && (
                    <div className="notify-icon"></div>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end" style={{ minWidth: '300px', maxWidth: '400px' }}>
                  <PerfectScrollbar 
                    className="widget-media dlab-scroll" 
                    style={{ maxHeight: '380px' }}
                    containerRef={(ref) => { scrollbarRef.current = ref; }}
                  >
                    <ul className="timeline" style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                      {loading && notifications.length === 0 ? (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#6b7280' }}>Loading notifications...</li>
                      ) : notifications.length === 0 ? (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#6b7280' }}>No notifications</li>
                      ) : (
                        notifications.map((notif, idx) => {
                          // Get the type label
                          const typeLabel = notificationTypeMap[notif.type] || "notification";
                          // Create a custom message
                          let message = "";
                          let highlightedTaskName = notif.task?.title ? <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{notif.task.title}</span> : '';
                          switch (notif.type) {
                            case 10:
                              message = <>You have been assigned to task {highlightedTaskName}</>;
                              break;
                            case 20:
                              message = <>You were tagged in task {highlightedTaskName}</>;
                              break;
                            case 30:
                              message = <>You are an observer for task {highlightedTaskName}</>;
                              break;
                            case 40:
                              message = <>You are a participant in task {highlightedTaskName}</>;
                              break;
                            case 50:
                              message = <>Your task {highlightedTaskName} status is changed to {returnStatusMap[notif.table_value]}</>;
                              break;
                            case 60:
                              message = <>A new comment was added to task {highlightedTaskName}</>;
                              break;
                            case 70:
                              message = <>Someone replied to your comment on task {highlightedTaskName}</>;
                              break;
                            case 80:
                              message = <>You were mentioned in task {highlightedTaskName}</>;
                              break;
                            case 90:
                              message = <>Task {highlightedTaskName} is starting in 2 days</>;
                              break;
                            case 100:
                              message = <>Task {highlightedTaskName} should have started but hasn't been activated</>;
                              break;
                            default:
                              message = notif.title || notif.message || notif.content || `Notification (Type: ${notif.type})`;
                          }
                          return (
                            <li
                              key={notif.id || idx}
                              onClick={() => handleNotificationClick(notif)}
                              className={`notification-item${notif.is_read ? ' read' : ''}`}
                              style={{ borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}
                            >
                              <div className="timeline-panel notificationlist-header marginbottom">
                                <div className="media-body">
                                  <p className="mb-1" style={{ fontSize: '14px', lineHeight: '1.4' }}>{message}</p>
                                  <small className="d-block" style={{ fontSize: '12px' }}>
                                    {notif.created_at && moment(notif.created_at).isValid()
                                      ? moment(notif.created_at).format("D MMMM YYYY")
                                      : "Date not available"}
                                  </small>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      )}
                      {loadingMore && (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#6b7280' }}>
                          Loading more...
                        </li>
                      )}
                      {!hasMore && notifications.length > 0 && (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#9ca3af', fontSize: '12px' }}>
                          No more notifications
                        </li>
                      )}
                    </ul>
                  </PerfectScrollbar>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown as="li" className="nav-item dropdown header-profile" style={{ marginLeft: '0px' }}>
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer"
                  role="button" data-toggle="dropdown"
                >
                  {/* Replace profile image with a generic avatar circle with initials */}
                  <div style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: '#e0e0e0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontSize: 16,
                    color: '#555',
                    marginRight: 8
                  }}>
                    {userName ? userName.split(' ').map(n => n[0]).join('').toUpperCase() : '?'}
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-3  mt-lg-0 dropdown-menu dropdown-menu-end">
                  {/* Profile Info */}
                  <div style={{ padding: '12px 16px', borderBottom: '1px solid #eee', minWidth: 220 }}>
                    <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 2 }}>{userName || 'User'}</div>
                    <div style={{ fontSize: 13, color: '#888' }}>{user && (() => { try { return JSON.parse(user).email || ''; } catch { return ''; } })()}</div>
                  </div>
                  {/* Edit Profile Option */}
                  {(() => {
                    let type = null;
                    try {
                      type = user && JSON.parse(user).type;
                    } catch { }
                    if (type === 'corporate') {
                      return <>
                        <EditProfileCorporate onEdit={() => {/* handle edit corporate */ }} />
                        <Dropdown.Item as={Link} to="/user-subscription">My Subscription</Dropdown.Item>
                        <Dropdown.Item as={Link} to="/changePassword">Change Password</Dropdown.Item>
                      </>;
                    } else if (type === 'user') {
                      return <>
                        <EditProfileCorporateUser onEdit={() => {/* handle edit corporate user */ }} />
                        <Dropdown.Item as={Link} to="/changePassword">Change Password</Dropdown.Item>
                      </>;
                    } else {
                      return null;
                    }
                  })()}

                  {/* Logout Option */}
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>

            </ul>
          </div>
        </nav>
        {unreadNotifications.length > 0 && isTickerVisible && (
          <div className="notification-ticker">
            <div className="notification-ticker__label">Latest</div>
            <div className="notification-ticker__viewport">
              <div className="notification-ticker__track">
                {unreadNotifications.map((notif, idx) => (
                  <span 
                    key={`unread-${idx}`} 
                    className="notification-ticker__item"
                    onClick={() => handleNotificationClick(notif)}
                  >
                    <span className="notification-ticker__number">{idx + 1}.</span>
                    {getNotificationMessage(notif, { plainText: true })}
                  </span>
                ))}
                {/* Duplicate to make the loop seamless */}
                {unreadNotifications.map((notif, idx) => (
                  <span 
                    key={`unread-dup-${idx}`} 
                    className="notification-ticker__item"
                    onClick={() => handleNotificationClick(notif)}
                  >
                    <span className="notification-ticker__number">{idx + 1}.</span>
                    {getNotificationMessage(notif, { plainText: true })}
                  </span>
                ))}
              </div>
            </div>
            <button
              type="button"
              className="notification-ticker__close"
              onClick={() => setIsTickerVisible(false)}
              aria-label="Close latest notifications ticker"
            >
              ×
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
